const Blockly = require('blockly');
const baseMdcBlockGroup = require('./_BaseMdcBlockGroup');

const TOOLTIPS = {
    RowHighlight:
        'Highlight the entire row or card background based on a color property from a foreign relation.',
    PillBox: 'Highlight individual values with a colored pill/badge based on a color property from a foreign relation.'
};

class DisplayModifier extends baseMdcBlockGroup {
    addCodeGeneratorCustom(code, blocklyBlock, hNodeType) {
        const colorProperty = blocklyBlock.getFieldValue('colorProperty');
        const metaDataFieldName = hNodeType === 'RowHighlight' ? 'rowHighlight' : 'pillBox';

        const childrenSecurityModifiers = Blockly.JavaScript.valueToCode(
            blocklyBlock,
            'securityModifier',
            Blockly.JavaScript.ORDER_NONE
        );
        let result = {};
        if (childrenSecurityModifiers) {
            result = JSON.parse(childrenSecurityModifiers);
        }
        result[metaDataFieldName] = colorProperty;
        return [JSON.stringify(result), Blockly.JavaScript.ORDER_NONE];
    }

    addToBlocks() {
        const mdcBlock = this;
        this.buildControls.forEach(function (hNodeType) {
            Blockly.Blocks[blockName(hNodeType, mdcBlock.hNodeTypeGroup)] = {
                init: function () {
                    const blocklyBlock = this;

                    blocklyBlock.setColour(mdcBlock.color[0]);
                    blocklyBlock.setTooltip(TOOLTIPS[hNodeType] || mdcBlock.blockDescription);

                    const topInput = blocklyBlock.appendValueInput('securityModifier').setCheck('securityModifier');
                    topInput
                        .appendField(hNodeType === 'RowHighlight' ? 'Row Highlight  |' : 'Pill Box  |')
                        .appendField('  Color Property:')
                        .appendField(new Blockly.FieldTextInput('color'), 'colorProperty');

                    blocklyBlock.setInputsInline(false);
                    blocklyBlock.setOutput(true, 'securityModifier');
                }
            };
        });
    }
}

module.exports = DisplayModifier;

function blockName(hNodeType, hNodeTypeGroup) {
    return hNodeTypeGroup + '_' + hNodeType;
}
